import React, {useCallback, useEffect, useRef, useState} from "react"
import {Box, IconButton, ListItemIcon, ListItemText, MenuItem, MenuList, Popover} from "@mui/material";
import maplibregl from "maplibre-gl";
import MapCircleIcon from "../../../../../resources/img/map_green_circle_icon.png"
import MapTriangleIcon from "../../../../../resources/img/map_red_triangle_icon.png"
import MaplibreManager from "../../../../manager/maplibre";
import axios from "axios";
import PropTypes from "prop-types";
import {MapLayerTitle, MapSelectableLayers, MapStyle} from "../../../../../data/map/state";
import MapSelectedMarkerLayer from "../../../../layers/selectedMarker";
import {Check as CheckIcon, Layers as LayersIcon, Map as MapIcon} from "@mui/icons-material";

const styles = {
    map: {
        border: '1px solid #bbb',
    },
    layerButton: {
        position: 'absolute',
        top: '4.3rem',
        right: '1rem',
        background: 'white',
        boxShadow: '#666 1px 1px 6px',
        borderRadius: '8px'
    },
    basemapButton: {
        position: 'absolute',
        top: '1rem',
        right: '1rem',
        background: 'white',
        boxShadow: '#666 1px 1px 6px',
        borderRadius: '8px'
    },
}

const TreeInfoDetailMapView = ({data}) => {

    const mapRef = useRef()
    const { addImageIcon } = MaplibreManager()
    const [map, setMap] = useState()
    const [style, setStyle] = useState()
    const [styleKey, setStyleKey] = useState("chiri_pale")

    useEffect(() => {
        if (map || !data) { return }

        const tm = setTimeout(() => {
            axios.get(`/resources/map_style/${styleKey}.json5`)
                .then(res => {
                    setStyle(res.data)
                    initMap(res.data)
                })
                .catch(e => {
                    console.log(e)
                })
        }, 100)


        return () => {
            clearTimeout(tm)
            setMap(null)
        }
    }, [data])

    useEffect(() => {
        if (!map || !style) { return }

        axios.get(`/resources/map_style/${styleKey}.json5`)
            .then(res => {
                setStyle(res.data)
            })
            .catch(e => {
                console.log(e)
            })

    }, [styleKey])

    const initMap = useCallback((style) => {
        if (map || !style) { return }
        const m = new maplibregl.Map({
            container: mapRef.current,
            center: [data.longitude, data.latitude],
            zoom: 18,
            style,
        })

        Promise.all([
            addImageIcon(m, MapCircleIcon, "circle-icon"),
            addImageIcon(m, MapTriangleIcon, "triangle-icon")
        ]).then(() => {
            console.log("[Map]", "map initialized", m)
        }).catch(e => {
            console.log("[Map]", "add icon error", e)
        })
        setMap(m)
    }, [map, style, data])

    return (
        <Box ref={mapRef} style={{width: "100%"}}>
            <MapSelectedMarkerLayer map={map} lngLat={data ? {lng: data.longitude, lat: data.latitude} : null} />
        </Box>
    )
}

TreeInfoDetailMapView.propTypes = {
    data: PropTypes.object,
}

export default TreeInfoDetailMapView
